import { gql } from "@apollo/client";

export const CREATE_SKYNET_USER = gql`
  mutation createSkynetUser($input: CreateSkynetUserInput!) {
    rolesAndPermissions {
      createSkynetUser(input: $input) {
        id
        success
      }
    }
  }
`;
